import { render, staticRenderFns } from "./AuditTrailView.vue?vue&type=template&id=50fb9685&"
import script from "./AuditTrailView.vue?vue&type=script&lang=js&"
export * from "./AuditTrailView.vue?vue&type=script&lang=js&"
import style0 from "./AuditTrailView.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports